// eslint-disable-next-line
export const getObjectEntries = <F extends Record<string, any>>(obj: F): [Extract<keyof F, string>, F[keyof F]][] => {
  return Object.entries(obj) as [Extract<keyof F, string>, F[keyof F]][];
};
